import React from 'react';
import PropTypes from 'prop-types';
import cname from '../WidgetStyles/style.module.scss';

/**
 * RangeSliderLabels:
 *  - Labels for left, middle and right points of RangeSlider
 */
export function RangeSliderLabels(props) {
  return (
    <div className={cname.inputLabels}>
      {props.left && <p className={cname.left}>{props.left}</p>}
      {props.middle && <p className={cname.middle}>{props.middle}</p>}
      {props.right && <p className={cname.right}>{props.right}</p>}
    </div>
  );
}

RangeSliderLabels.propTypes = {
  /**
   * Label for leftmost point in slider
   */
  left: PropTypes.string,
  /**
   * Label for middle point in slider
   */
  middle: PropTypes.string,
  /**
   * Label for rightmost point in slider
   */
  right: PropTypes.string,
};

RangeSliderLabels.defaultProps = {
  left: '',
  middle: '',
  right: '',
};
